import { create } from "zustand";

export interface PendingGeneration {
  nodeId: string;
  sceneId: string;
  videoId: string;
  projectId: string;
  videoName: string;
  operationName: string;
  createdAt: string;
}

interface VideoGenerationState {
  pending: PendingGeneration | null;
  isPolling: boolean;
  completedVideoId: string | null;
  completedProjectId: string | null;
  completedProjectName: string | null;
  errorMessage: string | null;
  lastError: Date | null;

  setPending: (pending: PendingGeneration | null) => void;
  setIsPolling: (isPolling: boolean) => void;
  setCompleted: (params: {
    videoId: string;
    projectId: string;
    videoName: string;
  }) => void;
  clearCompleted: () => void;
  setError: (message: string) => void;
  clearError: () => void;
  clear: () => void;
}

export const useVideoGenerationStore = create<VideoGenerationState>((set) => ({
  pending: null,
  isPolling: false,
  completedVideoId: null,
  completedProjectId: null,
  completedProjectName: null,
  errorMessage: null,
  lastError: null,

  setPending: (pending) => { set({ pending }); },
  setIsPolling: (isPolling) => { set({ isPolling }); },
  setCompleted: ({ videoId, projectId, videoName }) =>
    { set({
      pending: null,
      isPolling: false,
      completedVideoId: videoId,
      completedProjectId: projectId,
      completedProjectName: videoName,
    }); },
  clearCompleted: () =>
    { set({
      completedVideoId: null,
      completedProjectId: null,
      completedProjectName: null,
    }); },
  setError: (message) =>
    { set({
      errorMessage: message,
      lastError: new Date(),
    }); },
  clearError: () =>
    { set({
      errorMessage: null,
      lastError: null,
    }); },
  clear: () =>
    { set({
      pending: null,
      isPolling: false,
      completedVideoId: null,
      completedProjectId: null,
      completedProjectName: null,
      errorMessage: null,
      lastError: null,
    }); },
}));
